module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "registration"
  }, [_c('inline-svg', {
    attrs: {
      "src": require('../../assets/svg/x.svg').default
    },
    on: {
      "click": _vm.goBack
    }
  }), _vm._v(" "), _c('h2', [_vm._v("\n    " + _vm._s(_vm.$t("registration.registration.text1")) + "\n    "), _c('inline-svg', {
    staticClass: "lockbreak",
    attrs: {
      "src": require('../../assets/svg/lockbreak.svg').default
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "modal-container",
    domProps: {
      "innerHTML": _vm._s(_vm.htmlModal)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('div', {
    staticClass: "register-text"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("registration.registration.text1")) + "\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.user) ? _c('div', [_c('GoogleButton')], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "program-choose"
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text3")))]), _vm._v(" "), (!_vm.payment_options.length) ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t("registration.registration.loading")) + "\n      "), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.payment_options), function(option, idx) {
    return _c('div', {
      key: idx,
      staticClass: "program-option",
      class: {
        chosenOption: _vm.chosenPayment == idx + 1,
        bestOption: option.recommended
      },
      on: {
        "click": function($event) {
          _vm.chosenPayment = idx + 1
        }
      }
    }, [(option.recommended) ? _c('div', {
      staticClass: "recomanded",
      class: _vm.ltr ? 'recommended-left' : 'recommended-right'
    }, [_vm._v(_vm._s(_vm.$t("registration.registration.recommended")))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.text))]), _vm._v(" "), _c('div', {
      staticClass: "prices"
    }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t("registration.registration.sum")) + " ₪" + _vm._s(Math.round(option.price) * (option.recurring || 1)))]), _vm._v(" "), _c('span', {
      staticClass: "monthp"
    }, [_vm._v("₪" + _vm._s((Math.round(option.price) / (option.months || 1)).toFixed(1)) + "\n          " + _vm._s(_vm.$t("registration.registration.month")))])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.user) ? _c('div', {
    staticClass: "submit-payment"
  }, [_c('button', {
    on: {
      "click": _vm.goPay
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("registration.registration.payment")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "disclaimer-text"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("registration.registration.disclaimer.part_1")) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t("registration.registration.disclaimer.part_2")))]), _vm._v(". " + _vm._s(_vm.$t("registration.registration.disclaimer.part_3")) + "-" + _vm._s(new Date().toLocaleDateString('he-il')) + " " + _vm._s(_vm.$t("registration.registration.disclaimer.part_4")) + " " + _vm._s(_vm.getSelectedPlanCycle()) + ". " + _vm._s(_vm.$t("registration.registration.disclaimer.part_5")) + ".\n    ")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "footerLinks"
  }, [_c('span', {
    on: {
      "click": _vm.goToWA
    }
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text4")))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('privacy')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text5")))]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.navigate('terms')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("registration.registration.text6")))])]), _vm._v(" "), (_vm.user) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/payment_logos.svg")
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf7f3b7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration/registration.vue
// module id = 482
// module chunks = 12